import { useSeason } from "@/hooks/useSeason";

function formatCountdown(seconds) {
  if (!seconds || seconds <= 0) return "—";
  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  if (d > 0) return `${d}d ${h}h`;
  const m = Math.floor((seconds % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  const s = seconds % 60;
  return `${m}m ${s}s`;
}

/** Compact season pill — sits in the header. */
export function SeasonPill() {
  const season = useSeason();
  if (!season) return null;
  const isFreeze = season.state === "NATIONAL_FREEZE";
  const isIntl = season.state === "INTERNATIONAL";
  const label = isIntl ? "Finals live"
    : isFreeze ? "Season closed"
    : `Day ${season.day}/30`;
  const countdown = isIntl ? "—" : (isFreeze ? "Finals next" : formatCountdown(season.national_freeze_in));
  return (
    <div className="flex items-center gap-3 px-3 py-1 border border-nk-line rounded-sm text-xs">
      <span className="text-nk-mute">Season {season.season_number}</span>
      <span className="font-mono text-nk-text">{label}</span>
      <span className="text-nk-dim">·</span>
      <span className="font-mono text-nk-accent">{countdown}</span>
    </div>
  );
}

/** Big countdown card used on Landing / Home. */
export function SeasonCountdown() {
  const season = useSeason();
  if (!season) return null;
  return (
    <div className="nk-card p-6">
      <div className="flex items-baseline justify-between">
        <p className="eyebrow">Season {season.season_number}</p>
        <span className="text-xs text-nk-dim font-mono">Day {season.day} of 30</span>
      </div>
      <div className="mt-4 grid grid-cols-3 gap-4">
        <CountdownCell label="National Finals in" seconds={season.national_freeze_in} />
        <CountdownCell label="Internationals in" seconds={season.international_in} accent />
        <CountdownCell label="Next season in" seconds={season.next_season_in} />
      </div>
      <div className="mt-5 h-1 bg-nk-line rounded-full overflow-hidden">
        <div className="h-full bg-nk-accent transition-all" style={{ width: `${Math.min(100, (season.day / 30) * 100)}%` }} />
      </div>
    </div>
  );
}

function CountdownCell({ label, seconds, accent = false }) {
  return (
    <div>
      <p className="text-xs text-nk-mute mb-1">{label}</p>
      <p className={`font-display text-2xl font-medium ${accent ? "text-nk-accent" : ""}`}>{formatCountdown(seconds)}</p>
    </div>
  );
}
